import { ForgotPassword } from './ForgotPassword'
import { CodeRecovery } from './CodeRecovery'
import { NewPassword } from './NewPassword'
import { useLocation } from 'react-router-dom'
import { useState } from 'react'

const RecoverPassword = () => {
  const location = useLocation()
  const [cpf, setCpf] = useState<string>('')
  const [token, setToken] = useState<string>('')

  const renderStep = () => {
    switch (location.pathname) {
      case '/forgot-password':
        return <ForgotPassword onCpfSet={setCpf} />
      case '/code-recovery':
        return <CodeRecovery cpf={cpf} onTokenSet={setToken} />
      case '/new-password':
        return <NewPassword token={token} />
      default:
        return <ForgotPassword onCpfSet={setCpf} />
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-md">{renderStep()}</div>
    </div>
  )
}

export default RecoverPassword
